import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ToolsPage from './pages/ToolsPage';

// 创建一个提供Markdown上下文的组件
const MarkdownContext = React.createContext<any>(null);

export const MarkdownProvider: React.FC<{children: React.ReactNode}> = ({ children }) => {
  const [markdownState] = React.useState({
    markdown: '',
    renderedMarkdown: ''
  });

  return (
    <MarkdownContext.Provider value={markdownState}>
      {children}
    </MarkdownContext.Provider>
  );
};

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/tools" element={<ToolsPage />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;